import React from "react";
import { CardBody, Row, Col, Button } from "reactstrap";

const Unfinished = ({ id }) => {
  return (
    <div className="content questionsArea mock-already-completed">
      <Row>
        <Col xs={12}>
          <CardBody>
            <Row className="testFinish unselectable">
              <div className="col-sm-12">
                <p>
                  <span>
                    This mock is unfinished. Please{" "}
                    <a href={`/admin/pending/new-sectional-tests`}>
                      <Button color="primary" size="xs">
                        Click here
                      </Button>
                    </a>{" "}
                    to resume this test.
                  </span>
                </p>
              </div>
            </Row>
          </CardBody>
        </Col>
      </Row>
    </div>
  );
};

export default Unfinished;
